import { render, staticRenderFns } from "./CustomFieldFundingScatterChart.vue?vue&type=template&id=67215f57&"
import script from "./CustomFieldFundingScatterChart.vue?vue&type=script&lang=js&"
export * from "./CustomFieldFundingScatterChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports